// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Super-admin dashboard (/admin). Scoped under .admin-dashboard. */

.admin-dashboard {
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-4);
  min-width: 0;
}

.admin-dashboard .admin-dashboard__card {
  height: 100%;
  border-radius: var(--ds-radius-lg);
  box-shadow: var(--ds-shadow-xs);
  min-width: 0;
}

.admin-dashboard .admin-dashboard__kpi-link {
  display: block;
  height: 100%;
  color: inherit;
  text-decoration: none;
}

.admin-dashboard .admin-dashboard__kpi-link:focus-visible {
  outline: none;
  box-shadow: var(--ds-focus-ring);
  border-radius: var(--ds-radius-lg);
}

.admin-dashboard__kpi-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--ds-space-2);
}

.admin-dashboard__kpi-label {
  color: var(--ds-text-2);
  font-weight: 600;
  overflow-wrap: anywhere;
  min-width: 0;
}

.admin-dashboard__kpi-icon {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: var(--ds-radius-md);
  font-size: 18px;
}

.admin-dashboard__kpi-value {
  margin-block: var(--ds-space-2) var(--ds-space-1);
  font-size: 1.75rem;
  font-weight: 700;
  line-height: 1.1;
  color: var(--ds-text);
  font-variant-numeric: tabular-nums;
}

.admin-dashboard__muted {
  color: var(--ds-text-muted);
  font-size: 0.875rem;
  overflow-wrap: anywhere;
}

.admin-dashboard__chart {
  width: 100%;
  min-width: 0;
}

/* Phones: two tiles per row, so tighten the tile padding and number size. */
@media (max-width: 767.98px) {
  .admin-dashboard .admin-dashboard__kpi .ant-card-body {
    padding: var(--ds-space-3);
  }

  .admin-dashboard__kpi-value {
    font-size: 1.5rem;
  }

  .admin-dashboard__kpi-icon {
    width: 32px;
    height: 32px;
    font-size: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/admin/components/dashboard/AdminDashboard.css"],"names":[],"mappings":"AAAA,mEAAmE;;AAEnE;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,kCAAkC;EAClC,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,iDAAiD;EACjD,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,4EAA4E;AAC5E;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;AACF","sourcesContent":["/* Super-admin dashboard (/admin). Scoped under .admin-dashboard. */\n\n.admin-dashboard {\n  display: flex;\n  flex-direction: column;\n  gap: var(--ds-space-4);\n  min-width: 0;\n}\n\n.admin-dashboard .admin-dashboard__card {\n  height: 100%;\n  border-radius: var(--ds-radius-lg);\n  box-shadow: var(--ds-shadow-xs);\n  min-width: 0;\n}\n\n.admin-dashboard .admin-dashboard__kpi-link {\n  display: block;\n  height: 100%;\n  color: inherit;\n  text-decoration: none;\n}\n\n.admin-dashboard .admin-dashboard__kpi-link:focus-visible {\n  outline: none;\n  box-shadow: var(--ds-focus-ring);\n  border-radius: var(--ds-radius-lg);\n}\n\n.admin-dashboard__kpi-head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: var(--ds-space-2);\n}\n\n.admin-dashboard__kpi-label {\n  color: var(--ds-text-2);\n  font-weight: 600;\n  overflow-wrap: anywhere;\n  min-width: 0;\n}\n\n.admin-dashboard__kpi-icon {\n  display: inline-flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border-radius: var(--ds-radius-md);\n  font-size: 18px;\n}\n\n.admin-dashboard__kpi-value {\n  margin-block: var(--ds-space-2) var(--ds-space-1);\n  font-size: 1.75rem;\n  font-weight: 700;\n  line-height: 1.1;\n  color: var(--ds-text);\n  font-variant-numeric: tabular-nums;\n}\n\n.admin-dashboard__muted {\n  color: var(--ds-text-muted);\n  font-size: 0.875rem;\n  overflow-wrap: anywhere;\n}\n\n.admin-dashboard__chart {\n  width: 100%;\n  min-width: 0;\n}\n\n/* Phones: two tiles per row, so tighten the tile padding and number size. */\n@media (max-width: 767.98px) {\n  .admin-dashboard .admin-dashboard__kpi .ant-card-body {\n    padding: var(--ds-space-3);\n  }\n\n  .admin-dashboard__kpi-value {\n    font-size: 1.5rem;\n  }\n\n  .admin-dashboard__kpi-icon {\n    width: 32px;\n    height: 32px;\n    font-size: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
